import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './styles.module.styl';

const VoteButtons = ({ vote, submit }) => (
  <div className={styles.buttonGroup}>
    <button
      className={cx(styles.button, styles.buttonPositive, vote && styles.voted, vote === 'positive' && styles.activated)}
      onClick={() => !vote && submit('positive')}
    >
      <img alt="vote yes" src={vote === 'positive' ? '/docs/img/thumbs-up-activated.svg' : '/docs/img/thumbs-up.svg'} />
    </button>
    <button
      className={cx(styles.button, styles.buttonNegative, vote && styles.voted, vote === 'negative' && styles.activated)}
      onClick={() => !vote && submit('negative')}
    >
      <img alt="vote no" src={vote === 'negative' ? '/docs/img/thumbs-down-activated.svg' : '/docs/img/thumbs-down.svg'} />
    </button>
  </div>
);

VoteButtons.propTypes = {
  submit: PropTypes.func.isRequired,
  vote: PropTypes.string
};

export default VoteButtons;
